import { closeBtn } from 'icons/close';
import './modal.scss';

export const ModalTemplate = (model) => {
	const { wrapperId, contentId, contentCss = '', closeable = true } = model || {};

	/* html */
	const closeButton = closeable
		? `<span 
			tabindex="0"
			class="engt-modal-close tab-selectable"
			data-wid="${wrapperId}" data-cid="${contentId}">
			${closeBtn('#000')}
			</span>`
		: '';

	/* html */
	const html = `
		<div id="${contentId}" class="engt-modal-content" style="${contentCss}">
			${closeButton}
			<modal-content></modal-content>
		</div>
    `;

	return html;
};
